import React from "react";
import PropTypes from "prop-types";
import {
  getBaseButtonClasses,
  getIconSpacingClasses,
  wrapWithLoadingSpinner,
} from "../../design-system/components/buttons/buttonUtils";
import {
  affiliateAccentGradientButton,
  affiliateButtonLabel,
} from "../utils/uiClasses";

/**
 * Affiliate portal primary CTA.
 *
 * Do NOT use design-system PrimaryButton here: the repo Tailwind config sets
 * `important: true`, so PrimaryButton's `from-blue-600` / `to-sky-500` win over
 * purple/pink override classes by CSS source order (blue → fuchsia → sky).
 * This component only applies the affiliate purple → pink gradient.
 */
const AffiliatePrimaryButton = ({
  children,
  onClick,
  type = "button",
  size = "md",
  disabled = false,
  loading = false,
  fullWidth = false,
  leftIcon = null,
  rightIcon = null,
  className = "",
  ...rest
}) => {
  const classes = [
    getBaseButtonClasses({ size, disabled, fullWidth, loading }),
    "focus:ring-2 focus:ring-offset-2",
    affiliateAccentGradientButton,
    affiliateButtonLabel,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      className={classes}
      aria-busy={loading}
      {...rest}
    >
      {!loading && leftIcon ? (
        <span className={getIconSpacingClasses("left", !!children)}>{leftIcon}</span>
      ) : null}
      {wrapWithLoadingSpinner(loading, children, size)}
      {!loading && rightIcon ? (
        <span className={getIconSpacingClasses("right", !!children)}>{rightIcon}</span>
      ) : null}
    </button>
  );
};

AffiliatePrimaryButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  leftIcon: PropTypes.node,
  rightIcon: PropTypes.node,
  className: PropTypes.string,
};

export default AffiliatePrimaryButton;
